import styled from "styled-components";
import { STPaper } from "@src/Components/Ui/STPaperOverflow";

export const STMainWrapper = styled.div`
  && {    
    width: 100%
  }
`;

export const CSTPaper = styled(STPaper)`
{
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
`;
